<template>
  <div data-v-03b1ba29="" class="payment-method dekbox">
    <div class="demain">
      <div data-v-03b1ba29="" class="payment-wrapper">
        <span data-v-03b1ba29="" class="payment-title">{{ $t('_h._ye') }}: ${{ wallet.balance }}</span>
      </div>
      <div data-v-03b1ba29="" class="payment-wrapper">
        <span data-v-03b1ba29="" class="payment-title">{{ $t('_sp._dbye') }}: ${{ wallet.video }}</span>
      </div>
      <div data-v-03b1ba29="" class="payment-wrapper">
        <span data-v-03b1ba29="" class="payment-title">{{ $t('_sp._txje') }}</span>
        <div data-v-03b1ba29="" class="payment-item-wrapper" style="gap: 15px">
          <div class="czll" :class="{ active: index == 1 }" @click="onVideo(1, 299)">$299</div>
          <div class="czll" :class="{ active: index == 2 }" @click="onVideo(2, 399)">$399</div>
          <div class="czll" :class="{ active: index == 3 }" @click="onVideo(3, 599)">$599</div>
        </div>
      </div>
      <!-- <div data-v-03b1ba29="" class="payment-wrapper">
        <span data-v-03b1ba29="" class="payment-title">{{ $t('_sp._txje') }}</span>
        <div data-v-03b1ba29="" class="payment-item-wrapper">
          <input v-model="params.number" type="number" class="input-box" :placeholder="$t('_sp._qsrtxje')" />
        </div>
      </div> -->
    </div>
  </div>
  <div data-v-03b1ba29="" class="payment-footer btnc">
    <button data-v-03b1ba29="" class="payment-btn" @click="onTransfer()">
      <span data-v-03b1ba29="">{{ $t('_sp._ljhz') }}</span>
    </button>
    <button data-v-03b1ba29="" class="payment-btn btnf" @click="onBack('wallet')">
      <span data-v-03b1ba29="">{{ $t('_sp._fanh') }}</span>
    </button>
  </div>
  <!-- <div data-v-4490912c="" data-v-03b1ba29="" class="loading" style="display: none;"><img
                            data-v-4490912c="" src="https://www..cc/_nuxt/loading.Czr7mSn8.png"></div> -->
</template>

<script>
export default {
  name: 'depositVue',
  data() {
    return {
      wallet: {},
      index: 1,
      params: {
        number: 299
      }
    }
  },
  created() {
    this.getWallet()
  },
  methods: {
    onBack(name) {
      this.$router.push({ name: name })
    },
    onVideo(index, number) {
      this.index = index
      this.params.number = number
    },
    getWallet() {
      let that = this
      this.$api.userWallet.getWallet().then((res) => {
        if (res.data.length <= 0) {
          that.$message.error('error')
          return
        }
        that.wallet = res.data
      })
    },
    onTransfer() {
      if (this.params.number <= 0) {
        this.$message.error(this.$t('_sp._qshuru'))
        return
      }
      if (this.params.number > this.wallet.balance) {
        this.$message.error(this.$t('_sp._yebz'))
        return
      }

      var hide = this.$message.loading({ content: 'loading...', key: 'msg' })
      this.$api.userWallet.transfer(this.params).then((res) => {
        hide()
        if (res.data.code <= 0) {
          this.$message.error('error')
          return
        }
        this.$message.success('transfer success!')
        this.getWallet()
        this.params.number = ''
      })
    }
  }
}
</script>
<style scoped>
@import url('../../static/css_deposit/index.B4UqQ7MX.css');
</style>
<style>
.dekbox {
  padding-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.demain {
  width: 1200px;
}

.record-a {
  padding-top: 36px;
}

.asdrt {
  color: #fff;
  font-family: Ubuntu-Medium;
  font-size: 18px;
  font-weight: 500;
  line-height: 18px;
}

.czll {
  padding: 10px 30px;
  border: 2px solid #ffc107;
  border-radius: 10px;
  font-size: 20px;
  font-weight: bold;
  color: #ffc107;
  cursor: pointer;
}

.czll:hover {
  background-color: #f8d365;
  color: #a17f18;
}

.czll.active {
  background-color: #f8d365;
  color: #a17f18;
}
</style>
